"use strict";
/* eslint-disable max-len */
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleRegexPatterns = void 0;
const aptRegex = /(apt|bldg|dept|fl|hngr|lot|pier|rm|ste|slip|trlr|unit|#)\.? *[a-z0-9-]+\b/gi;
const poBoxRegex = /P\.? ?O\.? *Box +\d+/gi;
const roadRegex = /(street|st|road|rd|avenue|ave|drive|dr|loop|court|ct|circle|cir|lane|ln|boulevard|blvd|way)\.?\b/gi;
const phoneNumber = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm;
const emailAddress = /([a-z0-9_\-.+]+)@\w+(\.\w+)*/gi;
const streetAddress = new RegExp('(\\d+\\s*(\\w+ ){1,2}' +
    roadRegex.source +
    '(\\s+' +
    aptRegex.source +
    ')?)|(' +
    poBoxRegex.source +
    ')', 'gi');
exports.simpleRegexPatterns = {
    emailAddress,
    phoneNumber,
    streetAddress,
};
//# sourceMappingURL=simple-regex-patterns.js.map